module.exports = __webpack_public_path__ + "media/customizations/windler/back-bf624b035283af1715c7f0a7ab30b57f.jpg";